import { QUESTIONNAIRE } from './types';
import store from '../../../helpers/store';
import { isQuestionnaireAvailable } from '../../layers/widget/conditions';
import Logger from '../../../../common/logger';
import Tracker from '../../../genesys/tracker';

export const saveResponses = (responses) => {
    store.dispatch({
        type: QUESTIONNAIRE.SAVE_RESPONSES,
        data: {
            responses
        }
    });
};

export const saveResult = (result) => {
    store.dispatch({
        type: QUESTIONNAIRE.SAVE_RESULT,
        data: {
            result
        }
    });
};

export const submit = ({ isThankYouMessageSet, onClose }) => {
    store.dispatch({
        type: QUESTIONNAIRE.SUBMIT
    });
    if (!isThankYouMessageSet) {
        onClose();
    }
};

export const resetStore = () => {
    store.dispatch({
        type: QUESTIONNAIRE.RESET
    });
};

export const areConditionsMet = (source) => {
    const state = store.getState();

    if (state.questionnaire.conditionsMet !== null) {
        return state.questionnaire.conditionsMet;
    }

    const feature = isQuestionnaireAvailable(state);
    if (feature.available) {
        store.dispatch({
            type: QUESTIONNAIRE.SET_CONDITIONS_MET,
            data: {
                conditionsMet: true
            }
        });
        return true;
    } else {
        if (feature.level === 'error') {
            Logger.error(feature.reason);
        } else {
            Logger.log(feature.reason);
        }

        if (!state.widget.isInitView && feature.code) {
            Tracker.sendEvent('widgetReportQuestionnaire', {
                engagementID: state.config.widget.engagementID,
                resultID: feature.code,
                resultInfo: feature.reason,
                source: source
            });
        }
        store.dispatch({
            type: QUESTIONNAIRE.SET_CONDITIONS_MET,
            data: {
                conditionsMet: false
            }
        });
        return false;
    }
};
